import { useFilterSchema } from 'hooks/useFilterSchema'
import { useSelector } from 'react-redux'
import { selectSanitizedAppliedFiltersArray } from 'reducers/filtering/selectors'
import { RootState } from 'reducers/store'
import { selectUserSubscription } from 'reducers/subscription/selectors'

export const useAppliedFiltersAndContext = () => {
  const { filterSchema } = useFilterSchema()
  const appliedFilters = useSelector((state: RootState) =>
    selectSanitizedAppliedFiltersArray(state, { schema: filterSchema })
  )
  const context = useSelector((state: RootState) => selectUserSubscription(state))

  return { appliedFilters, context }
}
